<template>
  <load-area v-if="hotels == null"></load-area>
  <div class="row" v-if="hotels != null">
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead
            :title="'PMS Logs'"
            :buttons="[
              {
                title: 'Truncate',
                icon: 'fas fa-stop-circle',
                emit: 'Truncate',
              },
            ]"
            @truncate="truncate"
          ></cardHead>
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels row  p-20 p-b-10"
            ref="form"
          >
            <div class="col">
              <formGroup
                :title="'ReservationId'"
                v-model="model.ReservationId"
                :errors="errors"
                @keydown.enter="get()"
                :buttons="true"
              >
                <template #buttons>
                  <Btn
                    class="btn btn-success btn-xs waves-effect text-center"
                    @click="get()"
                    :process="process"
                    ><span class="fa fa-search"></span
                  ></Btn>
                </template>
              </formGroup>
            </div>
            <div class="col">
              <searchSelect
                :title="'SoftwareId'"
                v-model="model.SoftwareId"
                :errors="errors"
                :data="
                  $orderByArray(
                    softwares.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
            <div class="col">
              <searchSelect
                :title="'HotelId'"
                v-model="model.HotelId"
                :errors="errors"
                :data="
                  $orderByArray(
                    hotels.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
            <div class="col">
              <formGroup
                :title="'StartDate'"
                :type="'date'"
                :max="model.EndDate"
                v-model="model.StartDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'EndDate'"
                :type="'date'"
                :min="model.StartDate"
                v-model="model.EndDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col-auto">
              <div>
                <Btn
                  class="btn-success w100 tcenter"
                  @click="get()"
                  :disabled="reportProcess"
                  :process="reportProcess"
                  >Get</Btn
                >
              </div>
              <div>
              <Btn
                class="btn-info btn-xs w100 tcenter my-1"
                @click="model= {
        ReservationId: null,
        SoftwareId: null,
        HotelId: null,
        StartDate: null,
        EndDate: null,
      }"
                :disabled="reportProcess"
                :process="reportProcess"
                >Clear Filter</Btn
              >
              </div>
            </div>
          </Form>
          <dataTable
            :name="'kolayrezPMSLogs'"
            v-if="data != null && !reportProcess"
            ref="agGrid"
            :columnDefs="columnDefs"
            :data="data"
            @cellClicked="showShow = $event?.data"
            :rowClassRules="{
              // row style function
              danger: (params) => {
                // var numSickDays = params.data;
                return params?.data?.HasError;
              },
            }"
          ></dataTable>
          <load-area v-if="reportProcess" class="border-top"></load-area>
        </div>
      </div>
      <show
        v-if="showShow != null"
        :log="showShow"
        @close="showShow = null"
        @reload="reload"
      ></show>
    </div>
  </div>
</template>

<script>
import show from "./show";
import moment from "moment";
export default {
  name: "ScanErrors",
  components: { show },
  data() {
    return {
      softwares: [],
      hotels: [],
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          field: "Id",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "HotelId",
          field: "HotelId",
          filter: "agNumberColumnFilter",
          width: 80,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "HotelName",
          field: "HotelName",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Date",
          field: "Date",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
        {
          headerName: "FunctionName",
          field: "FunctionName",
          filter: "agTextColumnFilter",
          width: 350,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ErrorMessage",
          field: "ErrorMessage",
          filter: "agTextColumnFilter",
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
      ],
      data: null,
      showShow: null,
      model: {
        ReservationId: null,
        SoftwareId: null,
        HotelId: null,
        StartDate: null,
        EndDate: null,
      },
      reportProcess: false,
      report: [],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`CustomerHotels`).then((response) => {
      this.hotels = this.$orderByArray(response.data, "Name", false, false);
    });
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.softwares = response.data;
    });
    // this.getReport();
    // this.get();
  },
  watch: {
    // showShow(){
    //   window.open(
    //     "https://reservations.ams3.digitaloceanspaces.com/logs/"+this.showShow,
    //     '_blank' // <- This is what makes it open in a new window.
    //   );
    // }
  },
  methods: {
    get() {
      this.data = null;
      this.reportProcess = true;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/PMSLogs/Filter`, this.model)
        .then((response) => {
          this.data = this.$orderByArray(
            response.data,
            "Date",
            true,
            false,
            true
          );
          this.reportProcess = false;
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "Error",
            text: err,
          });
          this.data = [];
          this.reportProcess = false;
        });
    },
    reload() {
      this.get();
    },
    truncate() {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to truncate Asyasoft logs?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`KOLAYREZ/PMSLogs/Truncate`)
            .then(() => {
              this.reload();
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The successfully truncated.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
